import { atom } from 'jotai';

export const placesLibraryReadyAtom = atom(false);
